import * as angular from "angular";
import {ILocationService, ILogService, IRootScopeService, ISCEDelegateService} from "angular";
import uiRouter, {StateProvider, UrlRouterProvider} from "@uirouter/angularjs";
import "angular-local-storage";
import "angular-utf8-base64";
import "angularjs-slider";
import {DashboardComponent, LOCAL_STORAGE_KEY} from "./dashboard/dashboard.component";
import {AssessorComponent} from "./assessor/assessor.component";
import {AssessApplicationComponent} from "./application/assess-application.component";
import {ApplicationModule} from "../shared/application/application.module";
import {WidgetModule} from "../shared/widget/widget.module";
import {NotificationsModule} from "../shared/notifications/notifications.module";
import {StaffApplicationFooterComponent} from "./application/footer/staff-application-footer.component";
import {ApplicationHistoryComponent} from "./application/history/application-history.component";
import {ApplicationSummaryComponent} from "./application/summary/application-summary.component";
import {ApplicationsTableComponent} from "./application/table/applications-table.component";
import {MyApplicationAssessmentsComponent} from "./dashboard/my-application-assessments/my-application-assessments.component";
import {AssessmentModule} from "../shared/assessment/assessment.module";
import {NavigationModule} from "../shared/navigation/navigation.module";
import {ChatModule} from "../shared/chat/chat.module";
import {FirebaseService} from "../shared/firebase/firebase.service";
import {CourseService} from "../shared/course/course.service";
import {PreviousApplicationsComponent} from "./application/previous-applications/previous-applications.component";
import {ApplicationDocumentsComponent} from "./application/attachments/application-documents.component";
import {FacultyService} from "../shared/faculty/faculty.service";
import {GetStudentModalComponent} from "./dashboard/get-student-modal.component";
import {ChooseApplicationTimeRangeModalComponent} from "./dashboard/choose-application-time-range-modal.component";
import {Application} from "../shared/model/Application";
import {AddUnitComponent} from "../shared/assessment/add-unit.component";
import {ApplicationService} from "../shared/application/application.service";
import {DraftsTableComponent} from "./application/drafts-table/drafts-table.component";


export const StaffModule = angular
    .module("app.staff", [
        "utf8-base64",
        "LocalStorageModule",
        "ui.bootstrap",
        "rzModule",
        uiRouter,
        ApplicationModule,
        AssessmentModule,
        ChatModule,
        NavigationModule,
        NotificationsModule,
        WidgetModule
    ])

    .component("dashboard", DashboardComponent)
    .component("myApplicationAssessments", MyApplicationAssessmentsComponent)
    .component("assessor", AssessorComponent)
    .component("assessApplication", AssessApplicationComponent)
    .component("applicationFooterStaff", StaffApplicationFooterComponent)
    .component("applicationHistory", ApplicationHistoryComponent)
    .component("previousApplications", PreviousApplicationsComponent)
    .component("applicationSummary", ApplicationSummaryComponent)
    .component("applicationsTable", ApplicationsTableComponent)
    .component("applicationDocuments", ApplicationDocumentsComponent)
    .component("draftsTable", DraftsTableComponent)
    .component("addUnitComponent", AddUnitComponent)
    .component("getStudentModal", GetStudentModalComponent)
    .component("chooseApplicationTimeRangeModal", ChooseApplicationTimeRangeModalComponent)


    .config(($stateProvider: StateProvider, $urlRouterProvider: UrlRouterProvider) => {
        $urlRouterProvider.when("/staff", "/staff/dashboard");

        $stateProvider
            .state("staff", {
                parent: "app",
                abstract: true,
                url: "/staff",
                component: "layout",
                resolve: {
                    token: (firebaseService: FirebaseService) => {
                        if (!firebaseService.getToken()) {
                            return firebaseService.createToken()
                                .then(() => {
                                    firebaseService.signIn();
                                });
                        }
                    }
                }
            })

            .state("staff.dashboard", {
                url: "/dashboard?studentId",
                component: "dashboard",
                resolve: {
                    applications: ($log, $stateParams, currentUser, applicationService, localStorageService) => {
                        let filters = localStorageService.get(LOCAL_STORAGE_KEY);

                        if ($stateParams.studentId) {
                            filters = {
                                nameSearchTerm : $stateParams.studentId,
                                states: []
                            };
                            localStorageService.set(LOCAL_STORAGE_KEY, filters);
                        }

                        return applicationService.getLightStudentCreditApplications(filters);
                    }
                },
            })

            .state("staff.create", {
                url: "/application/:id",
                component: "application",
                resolve: {
                    applicant: (applicationService, $state, $stateParams, toaster) => {
                        return applicationService.getStudentDetailsById($stateParams.id).then((response) => {
                            return response;
                        }, (reason) => {
                            $state.go("staff.dashboard");
                        });
                    },
                    applicationHistories: () => null,
                    currentCourses: (currentUser, courseService: CourseService, $stateParams, applicant) => {
                        if (applicant) {
                            if (!currentUser.isProspectiveStudent && applicant.studentId) {

                                return courseService.getCurrentCourses(applicant.studentId).then((courses) => {

                                    return courses;
                                });



                            } else {
                                return [];
                            }
                        }
                    },
                    application: (applicant, currentCourses) =>  {
                        if (applicant) {
                            const application = new Application();
                            application.applicant = applicant;
                            return application;


                        }
                    },
                    teachingPeriods: (facultyService: FacultyService) => facultyService.getTeachingPeriods(),
                    assessments: () => null,
                    studentMode: () => false
                },
            })

            .state("staff.edit", {
                url: "/application-edit/:id",
                component: "application",
                resolve: {
                    application: (applicationService: ApplicationService, $stateParams) =>
                        $stateParams.id ?
                            applicationService.getStudentCreditRequestById($stateParams.id) :
                            null,
                    applicationHistories: () => null,
                    applicant: (application) => application.applicant,
                    currentCourses: (currentUser, courseService: CourseService, $stateParams, applicant) => {
                        if (applicant) {
                            if (applicant.studentId) {
                                return courseService.getCurrentCourses(applicant.studentId).then((courses) => {
                                    return courses;
                                });
                            } else {
                                return [];
                            }
                        }
                    },
                    teachingPeriods: (facultyService: FacultyService) => facultyService.getTeachingPeriods(),
                    assessments: () => null,
                    studentMode: () => false
                }
            })
            .state("staff.assess", {
                url: "/assess/:applicationId",
                component: "assessApplication",
                resolve: {
                    addViewAudit: ($stateParams, applicationService) => {
                        return applicationService.addViewHistoryByStaff($stateParams.applicationId);
                    },
                    application: (currentUser, $log, $stateParams, applicationService) => {
                        $log.debug("staff assess view:" + $stateParams.applicationId);
                        return applicationService.getStudentCreditApplicationById($stateParams.applicationId);
                    },
                    previousApplications: ($log, applicationService, application) => {
                        const studentId = application.applicant.studentId;
                        const facultyCode = application.owningFacultyCode;
                        $log.debug(`fetching previous applications for faculty: ${facultyCode} and student ${studentId}`);
                        return applicationService.getStudentCreditApplicationsForStudentAndFaculty(studentId, facultyCode);
                    },
                    applicationCourseOfferStatus: (currentUser, $log, $stateParams, applicationService) => {
                        return applicationService.getCourseOfferStatusByApplicationId($stateParams.applicationId);
                    },
                    applicationHistories: ($stateParams, applicationService) => {
                        return applicationService.getStudentCreditApplicationHistoryByApplicationId($stateParams.applicationId);
                    },
                    assessments: ($log, $stateParams, applicationService) => {
                        return applicationService.getAssessmentsByApplicationId($stateParams.applicationId);
                    },
                    currentCourses: (application, courseService: CourseService) => {
                        if (application.applicant && application.applicant.studentId) {
                            return courseService.getCurrentCourses(application.applicant.studentId);
                        } else {
                            return [];
                        }
                    },
                    studentMode: () => false
                },
            })

            .state("staff.assessor", {
                url: "/assessor/:applicationId/:userCheck",
                component: "assessor",
                resolve: {
                    application: (currentUser, $log, $stateParams, applicationService) => {
                        $log.debug("academic assessor view:" + $stateParams.applicationId);
                        return applicationService.getStudentCreditApplicationById($stateParams.applicationId);
                    },
                    assessments: (application, $log, $stateParams, applicationService) => {
                        $log.debug("Application id: %s", application.id);
                        $log.debug("assessmentId: %s", $stateParams.assessmentId);
                        // return applicationService.loadAssessment(application.id, $stateParams.assessmentId);
                        return applicationService.loadAssessmentforAssessor(application.id, $stateParams.userCheck);
                    },
                    userCheck: ($stateParams) => {
                        return $stateParams.userCheck;
                    }
                },
            })

            .state("staff.applicationSummary", {
                component: "applicationSummary",
                url: "/applications/:applicationId/summary",
                resolve: {
                    application: ($log, $stateParams, applicationService) => {
                        $log.debug("staff assess view:" + $stateParams.websafeKey);
                        return applicationService.getStudentCreditApplicationById($stateParams.applicationId);
                    },
                    assessments: ($log, $stateParams, applicationService) => {
                        return applicationService.getAssessmentsByApplicationId($stateParams.applicationId);
                    }
                }
            })

            .state("staff.applicationDocuments", {
                component: "applicationDocuments",
                url: "/applications/:applicationId/documents",
                resolve: {
                    application: ($log, $stateParams, applicationService) => {
                        $log.debug("staff assess view:" + $stateParams.websafeKey);
                        return applicationService.getStudentCreditApplicationById($stateParams.applicationId);
                    }
                }
            });
    })

    .run(($rootScope: IRootScopeService, $location: ILocationService, $log: ILogService, $sce: ISCEDelegateService) => {
        $log.debug("app.staff - Run");
    })

    .name;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/staff.module.ts